<div class="menu-container">
    <div class="menu-header">
        <div class="user-info">
            <span class="user-name">{{ userName }}</span>
            <span class="user-empresa">{{ currentEmpresa }}</span>
            <span class="user-base" *ngIf="baseName">{{ baseName }}</span>
        </div>
    </div>

    <div class="divider"></div>

    <div class="menu-item theme-toggle" (click)="toggleTheme($event)">
        <div class="item-label">
            <span class="material-symbols-rounded">dark_mode</span>
            <span>Modo Escuro</span>
        </div>
        <div class="toggle-switch" [class.active]="themeService.currentTheme() === 'dark'">
            <div class="slider"></div>
        </div>
    </div>

    <ng-container *ngIf="otherEmpresas.length > 0">
        <div class="divider"></div>

        <div class="company-section">
            <div class="section-label">Trocar empresa</div>

            <div class="company-list">
                <div class="menu-item empresa-item"
                     *ngFor="let empresa of otherEmpresas"
                     (click)="switchEmpresa($event, empresa)"
                     [class.loading]="isSwitching">
                    <div class="item-label">
                        <span class="material-symbols-rounded">business</span>
                        <span>{{ empresa.descricao }}</span>
                    </div>
                    <span class="material-symbols-rounded switch-arrow">chevron_right</span>
                </div>
            </div>

            <p class="switch-error" *ngIf="switchError">{{ switchError }}</p>
        </div>
    </ng-container>

    <div class="divider"></div>

    <div class="menu-item logout" (click)="logout($event)">
        <div class="item-label">
            <span class="material-symbols-rounded">logout</span>
            <span>Sair</span>
        </div>
    </div>
</div>
